import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "antd";
import { useMsal } from "@azure/msal-react";
import logo from "../assets/image.jpg";
import "../styles/login.css";
import { useAuth } from "../context/AuthContext";
import { setAuthToken } from "../api";

export default function Login() {
  const navigate = useNavigate();
  const { instance, accounts, inProgress } = useMsal();
  const { login } = useAuth();

  useEffect(() => {
    const authenticateUser = async () => {
      if (accounts.length > 0 && inProgress === "none") {
        try {
          const account = accounts[0];

          //  Get real access token for backend
          const response = await instance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: account,
          });

          const accessToken = response.accessToken;

          const userData = {
            email: account.username,
            name: account.name
          };

          // Save in context
          login(accessToken, userData);

          // Set axios Authorization header
          setAuthToken(accessToken);

          // Navigate to team page
          navigate("/team", { replace: true });

        } catch (error) {
          console.error("Token acquisition failed:", error);
        }
      }
    };

    authenticateUser();
  }, [accounts, inProgress, instance, login, navigate]);

  const handleMicrosoftLogin = async () => {
    if (inProgress !== "none") {
      return;
    }

    const redirectUri =
      process.env.REACT_APP_AZURE_REDIRECT_URI?.trim() ||
      (typeof window !== "undefined" ? window.location.origin : "");

    try {
      await instance.loginRedirect({
        scopes: ["openid", "profile", "email", "User.Read"],
        redirectUri,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" variant="outlined">
        <div className="logo-wrapper">
          <img src={logo} alt="Company Logo" />
        </div>

        <Button
          type="default"
          block
          size="large"
          style={{ marginBottom: "16px" }}
          onClick={handleMicrosoftLogin}
          disabled={inProgress !== "none"}
        >
          Login with Microsoft
        </Button>
      </Card>
    </div>
  );
}
